module.exports = __webpack_public_path__ + "static/media/truck-tick.305a5ea9.svg";